// extracted by mini-css-extract-plugin
module.exports = {"Link":"LogInSignUpForm_Link__cT1Gg"};